<template>
  <div>
    <div class="section-title section-title_app">
      <h3>RESULTADOS DEL DIA</h3>
    </div>
    <div class="columns is-multiline is-gapless">
      <div class="column is-12 has-background-white">
        <div style="display: flex; flex-wrap: wrap; padding: 16px;">
          <div class="column is-2">
            <b-field label="Fecha inicio"
                     label-position="on-border">
              <b-datepicker placeholder="2023" v-model="date_order" @input="() => this.getData()"
                            :max-date="maxDatetime"
                            nearby-selectable-month-days
                            :min-date="minDatetime"/>
            </b-field>
          </div>

          <div class="column is-2">
            <b-field label="Fecha final"
                    label-position="on-border">
              <b-datepicker placeholder="2023" v-model="date_order_end" @input="() => this.getData()"
                            :max-date="maxDatetime"
                            nearby-selectable-month-days
                            :min-date="minDatetime"/>
            </b-field>
          </div>
          <!-- <div class="column is-2">
            <b-field label="Firmado por"
                     label-position="on-border">
              <b-select v-model="signature_by" @input="() => this.getData()" expanded>
                <option value="">Todas</option>
                <option :value="doctors.id" :key="doctors.id"
                        v-for="doctors in doctors">{{ doctors.name }}
                </option>
              </b-select>
            </b-field>
          </div> -->
          <div class="column is-2">
            <b-field label="Estatus"
                     label-position="on-border">
              <b-select v-model="status" @input="() => this.getData()" expanded>
                <option value="">Todas</option>
                <option value="1">En proceso</option>
                <option value="2">Finalizada</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field label="Ver por página"
                     label-position="on-border">
              <b-select v-model="perPage" @input="() => this.getData()" expanded>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
                <option value="500">500 por página</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-2 has-text-right">
            <b-tooltip label="Exportar Excel">
              <b-button size="is-small" type="is-primary" @click="handleExport">Exportar Excel</b-button>
            </b-tooltip>
          </div>
          <div class="column is-12 has-text-right">
            <span><b>Total de encontrados: {{total}}</b></span>
          </div>
        </div>
      </div>

      <div class="column is-12 has-background-white">
        <div style="flex-wrap: wrap; padding: 27px;">
          <section>
            <b-table
                class="is-size-7"
                :data="data"
                :loading="loading"
                @select=handleSelectRow
                paginated
                :per-page="perPage"
                :current-page="currentPage"
                bordered
                narrowed
                backend-pagination
                @page-change="getData"
                :total="total"
                sticky-header
                :row-class="rowClass"
                height="100%">
              <b-table-column field="date" label="Fecha" v-slot="props">
                {{ props.row.date }}
              </b-table-column>
              <b-table-column field="order" label="Orden" v-slot="props">
                {{ props.row.order }}
              </b-table-column>
              <b-table-column field="paseProced" label="Pase" v-slot="props">
                {{ props.row.paseProced }}
              </b-table-column>
              <b-table-column field="folio" label="Folio" v-slot="props">
                {{ props.row.folio }}
              </b-table-column>
              <b-table-column field="patientName" label="Paciente" v-slot="props">
                {{ props.row.patientName }}
              </b-table-column>
              <b-table-column field="medicalName" label="Médico" v-slot="props">
                {{ props.row.medicalName }}
              </b-table-column>
              <b-table-column field="companyName" label="Empresa" v-slot="props">
                {{ props.row.companyName }}
              </b-table-column>
              <b-table-column field="studyDescription" label="Estudio" v-slot="props">
                {{ props.row.studyDescription }}
              </b-table-column>
              <b-table-column field="sign" label="Estatus" v-slot="props">
                <b-tag
                  :type="props.row.sign ? 'is-success' : 'is-warning'"
                >
                  {{ props.row.sign ? 'Finalizada' : 'En proceso' }}
                </b-tag>
              </b-table-column>
              <b-table-column field="medicalNameSign" label="Firmado por" v-slot="props">
                Clave: {{ props.row.sign }}<br>Nombre: {{ props.row.medicalNameSign }}
              </b-table-column>
              
              <b-table-column field="dateSignature" label="Día que firmaron el resultado" v-slot="props">
                {{ props.row.dateSignature }}
              </b-table-column>
              <b-table-column field="elaboro" label="Elaborado por" v-slot="props">
                {{ props.row.elaboro }}
              </b-table-column>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                          icon="box-open"
                          size="is-large">
                      </b-icon>
                    </p>
                    <p>No hay resultados para mostrar.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </section>
        </div>
      </div>
    </div>

    <b-modal v-model="showDetails">
      <details-task-monitor-xray :data="selectedRow"/>
    </b-modal>
  </div>
</template>

<script>
import DetailsTaskMonitorXray from "@/components/report/DetailsTaskMonitorXray";
/* import SelectCompany from "@/components/company/SelectCompany"; */
export default {
  name: "TaskMonitorXray",
  components: {
    DetailsTaskMonitorXray,
    /* SelectCompany, */
  },
  props: {},
  data() {
    const maxYear = new Date()
    maxYear.setFullYear(maxYear.getFullYear() + 1, 0, 0)
    const minYear = new Date()
    minYear.setFullYear(minYear.getFullYear() - 3, 12, 1)
    return {
      showDetails: false,
      perPage: 25,
      currentPage: 1,
      total: 0,
      data: [],
      date: new Date(),
      date_order: new Date(),
      date_order_end: new Date(),
      studyClasification: [],
      /* signature_by: '', */
      order: '',
      status:'',
      study: '',
      /* export_group: '', */
      /* company: '', */
      maxDatetime: maxYear,
      minDatetime: minYear,
      loading: true,
      searchingStudy: false,
      /* doctors: [], */
      /* selectedStudy: '', */
      selectedRow: {}
    }
  },
  computed: {
    /* branchOffices() {
      return this.$store.state.main.accountBranchOffices;
    }, */
    transformDate(){
      const new_date= `${this.date_order.getFullYear()}-${(this.date_order.getMonth()+1).toString().padStart(2, '0')}-${this.date_order.getDate().toString().padStart(2, '0')}`
      return new_date;
    },
    transformDate2(){
      const new_date= `${this.date_order_end.getFullYear()}-${(this.date_order_end.getMonth()+1).toString().padStart(2, '0')}-${this.date_order_end.getDate().toString().padStart(2, '0')}`
      return new_date;
    }
  },
  mounted() {
    /* this.getDoctorsWhoSigned(); */
    this.wrapper = document.getElementById('main-wrapper');
    this.wrapper.classList.add('is-expanded');
    this.getData()
    this.getStudyClasification()
  },
  methods: {
    getData(page = 1) {

      if(!this.checkDates()){
        return ;
      }

      this.loading = true;

      const params = {
        perPage: this.perPage, page,
        date: this.transformDate,
        date_order_end: this.transformDate2,
        /* signed_by: this.signature_by, */
        status: this.status,
      }
      /* console.log(this.signature_by, 'esto es lo que tiene en firmado por'); */
      this.$http.get('/specialties/monitor/pathology', {params}).then(async ({data}) => {
        console.log(data, 'esto es lo que llega');
        this.data = data.data
        this.total = data.meta.total;
        this.currentPage = page;
      }).finally(() => {
        this.loading = false;
      })
    },
    getStudyClasification() {
      this.$http.get('/studyClasification?xray=1').then(async ({data}) => {
        this.studyClasification = data.data
      })
    },
    rowClass(item) {
      return "lapi-monitor-" + item.rowColor;
    },
    handleExport(){
      if(!this.checkDates()){
        return ;
      }
      this.$loader.show();
      /* const study = this.selectedStudy ? this.selectedStudy.name : ''; */
      const params = {
        date: this.transformDate,
        date_order_end: this.transformDate2,
        /* signed_by: this.signature_by, */
        status: this.status,
      }
      this.$http.get(
        '/specialties/monitor/pathology/export',
        {
          params,
          responseType: 'blob'
        }
      ).then(response => {

        const date = this.$moment().format('Y-MM-DD');

        const blob = new Blob(
          [response.data],
          {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        );

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.setAttribute(
          'download',
          `monitor-pathology-${date}.xlsx`
        );

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

      }).finally(() => {
        this.$loader.hide();
      });
    },
    handleSelectRow(event) {
      console.log(event);
      this.showDetails=true;
      this.loading = true;
      const params = {
        orderNew: event.orderNew,
        codeStudy: event.codeStudy,
        codeSubStudy: event.codeSubStudy,
      }
      console.log(event.orderNew);
      this.$http.get(`/monitor/xray/details/${event.orderNew}/${event.codeStudy}/${event.codeSubStudy}`).then(async ({data}) => {
        this.selectedRow = data.data;
      }).finally(()=> {
        this.loading = false;
      })
    },
    checkDates() {
      let diff = Math.abs(this.date_order.getTime() - this.date_order_end.getTime());
      diff = diff / (1000*60*60*24);
      if(diff > 31){
        this.$buefy.dialog.alert({
          title: "Rango de fechas incorrecto",
          message: "No se puede seleccionar mas de un mes",
          canCancel: false
        });
        return false;
      }
      return true;
    },
    /* getDoctorsWhoSigned: async function() {
      console.log('ya llegue');
      const { data } = await this.$http.get(
        '/specialties/monitor/pathology/doctors'
      )
      console.log(data, 'estos son los doctores');
      this.doctors = data
    } */
  }
}
</script>

<style scoped>

</style>
